import { render, staticRenderFns } from "./ClientsActions.vue?vue&type=template&id=03c1a6f4&scoped=true&"
import script from "./ClientsActions.vue?vue&type=script&lang=js&"
export * from "./ClientsActions.vue?vue&type=script&lang=js&"
import style0 from "./ClientsActions.vue?vue&type=style&index=0&id=03c1a6f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c1a6f4",
  null
  
)

export default component.exports